// import React, { useEffect, useState } from 'react'
// import FilterProduct from './FilterProduct'
// import CardFeature from './CardFeature'
// import { useSelector } from 'react-redux'

// const AllProduct = ({heading}) => {
//     const productData= useSelector ((state)=>state.product.productList)
//     const categoryList= [...new Set(productData.map(el=>el.category))]
//     // console.log(categoryList)

//       //filterData display
//   const [dataFilter, setDataFilter]= useState([])
//   const [filterby, setFilterBy]= useState([])

//     useEffect(()=>{
//         setDataFilter(productData)
//     },[productData])

//     const handleFilterProduct= (category)=>{
//         setFilterBy(category)
//         const filter= productData.filter(el=> el.category.toLowerCase() === category.toLowerCase())
//         setDataFilter(()=>{
//         return[
//             ...filter
//         ]
//         })
//     }
    
//     const loadingArrayFeature= new Array(10).fill(null)



//     return (
//         <div className='my-5'>
//             <h2 className='font-bold text-2xl text-slate-800 mb-4'>
//             {heading}
//             </h2>

//             <div className='flex gap-4 justify-center overflow-scroll scrollbar-none'>
//             {
//                 categoryList[0]?
//                 categoryList.map(el=>{
//                     return(
//                         <FilterProduct
//                             category= {el}
//                             key={el}
//                             isActive= {el === filterby}
//                             onClick={()=>handleFilterProduct(el)} 

//                         />
//                     );
//                 })

//                 :

//                 <div className='min-h-[150px] flex justify-center items-center'>
//                     <p>Loading...</p>
//                 </div>
//             }
//             </div>
            

//             <div className='flex flex-wrap justify-center gap-4 my-4'>
//             {
//                 dataFilter[0]?
//                 dataFilter.map((el)=>{
//                     return(
//                         <CardFeature
//                         key= {el._id}
//                         id= {el._id}
//                         name={el.name}
//                         category={el.category}
//                         price={el.price}
//                         image={el.image}
//                         />
//                     )
//                 })

//                 :

//                 loadingArrayFeature.map((el, index)=>(
//                     <CardFeature loading= "Loading..." key={index+"allProduct"}/>
//                 ))

//             }
//             </div>


//         </div>
//     )
// }

// export default AllProduct


import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import CardFeature from './CardFeature';
import FilterProduct from './FilterProduct';
import { HiViewGrid, HiViewList } from 'react-icons/hi';

export default function AllProduct({ heading }) {
  const productData   = useSelector(s => s.product.productList);
  const categories    = [...new Set(productData.map(p => p.category))];

  const [filtered, setFiltered] = useState([]);
  const [activeFilter, setActive] = useState('');
  const [viewMode, setView]     = useState('grid');

  useEffect(() => { setFiltered(productData); }, [productData]);

  const handleFilter = useCallback((cat) => {
    if (activeFilter === cat) {
      setActive('');
      setFiltered(productData);
    } else {
      setActive(cat);
      setFiltered(productData.filter(p => p.category.toLowerCase() === cat.toLowerCase()));
    }
  }, [activeFilter, productData]);

  const skeletons = new Array(8).fill(null);

  return (
    <div>
      {/* Header row */}
      <div className="flex items-end justify-between mb-6 gap-4 flex-wrap">
        <div>
          <p className="section-eyebrow mb-2">Browse</p>
          <h2 className="font-display text-3xl font-bold" style={{ color: 'var(--text-primary)' }}>
            {heading?.toUpperCase() ?? 'ALL PRODUCTS'}
          </h2>
        </div>

        {/* View toggle */}
        <div
          className="flex items-center rounded-xl overflow-hidden"
          style={{ border: '1px solid var(--glass-border)', background: 'var(--bg-raised)' }}
        >
          {[
            { mode: 'grid', Icon: HiViewGrid },
            { mode: 'list', Icon: HiViewList },
          ].map(({ mode, Icon }) => (
            <button
              key={mode}
              onClick={() => setView(mode)}
              className="p-2.5 transition-all duration-200"
              style={{
                background: viewMode === mode ? 'var(--indigo-dim)' : 'transparent',
                color:      viewMode === mode ? 'var(--indigo-light)' : 'var(--text-muted)',
              }}
              aria-label={`${mode} view`}
            >
              <Icon className="text-lg" />
            </button>
          ))}
        </div>
      </div>

      {/* Filter pills */}
      <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1 mb-6">
        <button
          className={`filter-pill ${activeFilter === '' ? 'active' : ''}`}
          onClick={() => { setActive(''); setFiltered(productData); }}
        >
          All
        </button>
        {categories.length
          ? categories.map(cat => (
            <FilterProduct
              key={cat}
              category={cat}
              isActive={cat === activeFilter}
              onClick={() => handleFilter(cat)}
            />
          ))
          : <div className="skeleton h-8 w-24 rounded-full" />
        }
      </div>

      <div className="divider mb-8" />

      {/* ── GRID VIEW ─────────────────────────────────────────────────── */}
      {viewMode === 'grid' && (
        <div className="flex flex-wrap gap-5 justify-start">
          {filtered.length
            ? filtered.map((el, i) => (
              <div
                key={el._id}
                className="animate-fade-up"
                style={{ animationDelay: `${(i % 12) * 40}ms` }}
              >
                <CardFeature
                  id={el._id}
                  name={el.name}
                  category={el.category}
                  price={el.price}
                  image={el.image}
                />
              </div>
            ))
            : skeletons.map((_, i) => (
              <CardFeature key={i + 'sk'} loading="Loading..." />
            ))
          }
        </div>
      )}

      {/* ── LIST VIEW ─────────────────────────────────────────────────── */}
      {viewMode === 'list' && (
        <div className="flex flex-col gap-3">
          {filtered.length
            ? filtered.map((el, i) => (
              <div
                key={el._id}
                className="cart-row p-4 flex items-center gap-5 animate-fade-up"
                style={{ animationDelay: `${(i % 12) * 35}ms` }}
              >
                <div
                  className="w-20 h-20 flex-shrink-0 rounded-xl overflow-hidden flex items-center justify-center"
                  style={{ background: 'var(--bg-surface)' }}
                >
                  <img src={el.image} alt={el.name}
                       className="w-full h-full object-contain p-2" />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="badge mb-1 inline-block">{el.category}</span>
                  <h3 className="text-sm font-semibold capitalize truncate mt-1"
                      style={{ color: 'var(--text-primary)' }}>
                    {el.name}
                  </h3>
                  {el.description && (
                    <p className="text-xs mt-0.5 line-clamp-1"
                       style={{ color: 'var(--text-muted)' }}>
                      {el.description}
                    </p>
                  )}
                </div>
                <p className="font-display font-bold text-base flex-shrink-0">
                  <span style={{ color: 'var(--coral)' }}>₹</span>
                  <span className="text-gradient">{el.price}</span>
                </p>
              </div>
            ))
            : skeletons.map((_, i) => (
              <div key={i} className="skeleton rounded-2xl" style={{ height: 80 }} />
            ))
          }
        </div>
      )}
    </div>
  );
}